import React from 'react';

import ClickableIcon from '~components/ClickableIcon';
import { faPencil, faSave } from '~components/icon';

import { Row } from './types';

interface ComponentProps {
  row: Row;
  onEdit: (row: Row) => void;
  onSaveRow?: (row: Row) => void;
  isEditing?: boolean;
  editonly?: boolean;
  tooltip?: string;
  disabled?: boolean | ((row: Row) => boolean);
}

const EditAction: React.FC<ComponentProps> = ({
  row,
  onEdit,
  onSaveRow,
  isEditing,
  editonly,
  tooltip,
  disabled = false,
}) => {
  if (editonly) return null;
  return onSaveRow && isEditing ? (
    <ClickableIcon
      id={`${row.id}-save`}
      icon={faSave}
      size="small"
      color="success"
      onClick={() => {
        onEdit(row);
        onSaveRow(row);
      }}
    />
  ) : (
    <ClickableIcon
      id={`${row.id}-edit`}
      icon={faPencil}
      size="small"
      color="secondary"
      onClick={() => onEdit(row)}
      disabled={typeof disabled === 'function' ? disabled(row) : disabled}
      toolTip={tooltip ?? 'Toggle Edit'}
    />
  );
};

export default EditAction;
